module.exports = __webpack_public_path__ + "img/pagamento-realizado.bee19d20.svg";